/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Route, Router } from 'react-router-dom';
import { Translate } from 'react-localize-redux';
import App from '../App';
import SoothePlus from '../Containers/SoothePlus';
import PhoneNumberOptinPage from '../Containers/LandingPages/PhoneNumberOptin';
import CoronaLandingPage from '../Containers/LandingPages/Covid19';
import SignupModal from '../Containers/Shared/SignupModal';
import history from './history';
import SubscriptionLanding from '../Containers/SoothePlus/SubscriptionLanding';
import GiftCardsRedesign from '../Containers/GiftCardsRedesign';
import GiftCardsRedesignCheckout from '../Containers/GiftCardsRedesign/Checkout';
import AppointmentManagement from '../Containers/AppointmentManagement';
import AppointmentsList from '../Containers/AppointmentsList';
import Inbox from '../Containers/Inbox';
import BookingRedirection from '../Containers/Shared/BookingRedirection';
import Events from '../Containers/Events';
import SoothePass from '../Containers/SoothePass';
import InviteFriends from '../Containers/InviteFriends';
import PaymentMethods from '../Containers/PaymentMethods';
import AddressBook from '../Containers/AddressBook';
import AccountSettings from '../Containers/AccountSettings';
export const reactRoutes = (
  <Translate>
    {({ translate }) => (
      <Router history={history}>
        <>
          <Route path="/" component={App} />
          {/* why not change to '/booking' along with some BE config fix */}
          <Route path="/booking/:step?" component={BookingRedirection} />
          <Route exact path="/soothe-plus/subscribe" component={SoothePlus} />
          <Route exact path="/soothe-plus/" component={SubscriptionLanding} />
          <Route exact path="/phone-number-optin/" component={PhoneNumberOptinPage} />
          <Route exact path="/trust/coronavirus/" component={CoronaLandingPage} />
          <Route exact path="/sign_on/" component={SignupModal} />
          <Route exact path="/massage-cards/" component={GiftCardsRedesign} />
          <Route exact path="/massage-cards/checkout/" component={GiftCardsRedesignCheckout} />
          <Route exact path="/wellness-services/" component={GiftCardsRedesign} />
          <Route exact path="/wellness-services/checkout/" component={GiftCardsRedesignCheckout} />
          <Route exact path="/gift-cards/" component={GiftCardsRedesign} />
          <Route exact path="/gift-cards/checkout/" component={GiftCardsRedesignCheckout} />
          <Route exact path="/appointment_management/" component={AppointmentManagement} />
          <Route exact path="/appointments/" component={AppointmentsList} />
          <Route exact path="/inbox/" component={Inbox} />
          <Route exact path="/account/soothe-pass/" component={SoothePass} />
          <Route exact path="/account/invite-friends/" component={InviteFriends} />
          <Route exact path='/account/settings/' component={AccountSettings} />
          <Route exact path='/account/payment-methods/' component={PaymentMethods} />
          <Route exact path='/account/address-book/' component={AddressBook} />
          <Route path="/events-booking" component={Events} />
        </>
      </Router>
    )}
  </Translate>
);
